export default function PrivacyPolicyPage() {
	return (
		<div>
			<h1 className="my-6 text-2xl">Privacy Policy</h1>
			<div className="px-40">
				<h4 className="py-4 text-lg font-bold">1. Introduction</h4>
				<p>
					My Career Chat ("we", "our" or "us") is committed to respect and
					protect your privacy. We understand the importance of privacy and are
					committed to maintaining the confidentiality of your personal
					information. This privacy policy applies to the collection, storage,
					use, and dissemination of personal information by us.
				</p>
				<h4 className="py-4 text-lg font-bold">2. Information</h4>
				<p>We Collect We collect the following personal data:</p> <p>a) Name</p>
				<p>b) Email address</p>
				<p>c) Visitor information from our website</p>
				<p>d) Professional career history</p>
				<p>
					This information is collected to deliver, improve our services, and
					maintain the security of our systems.
				</p>
				<h4 className="py-4 text-lg font-bold">
					3. Use of Collected Information
				</h4>
				<p></p>
				<p>
					We may use the information we collect for various purposes, including
					to:
				</p>
				<p>a) Provide and maintain our services</p>
				<p>b) Provide customer support</p>
				<p>c) Detect, prevent, and address technical issues</p>
				<p>d) Improve and analyze our service</p>
				<p>e) Track the activity on our service</p>
				<h4 className="py-4 text-lg font-bold">4. Disclosure of Information</h4>
				<p>
					Your Career Story does not share, sell, rent, or trade User Personal
					Information with third parties for their commercial purposes. We only
					disclose User Personal Information as described below.
				</p>
				<p>
					We may use third-party service providers to monitor and analyze the
					use of our service. These third-party service providers have access to
					your personal data only to perform these tasks on our behalf and are
					obligated not to disclose or use it for any other purpose.
				</p>
				<p>We currently use the following third-party service providers:</p>
				<ul className="ml-6 list-disc">
					<li>Amazon Web Services (AWS)</li>
					<li>Prisma</li>
					<li>BrainTrust Data</li>
					<li>OpenAI</li>
					<li>HuggingFace</li>
					<li>Google Cloud</li>
					<li>Coda</li>
					<li>Amplitude</li>
					<li>Hotjar</li>
				</ul>
				<h4 className="py-4 text-lg font-bold">
					5. Security of Your Personal Information
				</h4>
				<p>
					My Career Chat is committed to protecting your personal information.
					We use a variety of security technologies and procedures to help
					protect your personal information from unauthorized access, use, or
					disclosure. However, no method of transmission over the internet, or
					method of electronic storage, is 100% secure. Therefore, while we
					strive to use commercially acceptable means to protect your personal
					information, we cannot guarantee its absolute security.
				</p>
				<h4 className="py-4 text-lg font-bold">6. Your Rights</h4>
				<p>
					You have the right to access, correct, or delete your personal data.
					You can do this by reaching out to us at mycareerchat.ai@gmail.com. We
					will respond to your request within a reasonable timeframe.
				</p>
				<h4 className="py-4 text-lg font-bold">
					7. Changes to this Privacy Policy
				</h4>
				<p>
					We may update our privacy policy from time to time. We will notify you
					of any changes by posting the new privacy policy on this page.
				</p>
				<h4 className="py-4 text-lg font-bold">8. Contact Us</h4>
				<p>
					If you have any questions or concerns about this privacy policy,
					please contact us at mycareerchat.ai@gmail.com.
				</p>
				<h4 className="py-4 text-lg font-bold">9. Jurisdiction</h4>
				<p>
					This privacy policy will be governed by the laws of California, United
					States of America.
					<h4 className="py-4 text-lg font-bold">10. Consent</h4>By using our
					service, you hereby consent to our privacy policy and agree to its
					terms.
				</p>
				<p>This privacy policy was last updated on August 18, 2023.</p>
			</div>
		</div>
	)
}
